export default "__VITE_PUBLIC_ASSET__17ac7b3c__"